import en from "./locale/en";
import de from "./locale/de";

const locale = {
  en: en,
  de: de
};

export function translate(
  language = 'de',
  key: string,
  value: (
    string |
    {
      key: string;
      val: any;
    }
  )
) {
  if (value && typeof value === "object") {
    let valueKey = value.key;
    const val = value.val;

    if (val === 0) {
      valueKey += "_zero";
    } else if (val === 1) {
      valueKey += "_singular";
    }

    const translatedText = locale[language][key][valueKey];

    if (val === 0) return translatedText;

    return val + " " + translatedText;
  } else {
    let item = locale[language];
    if (typeof item === "object") item = item[key];
    if (typeof item === "object") return item[value] || "";
    return item || "";
  }
}
